import { storageDateFormat } from '@/core';
import deepCopy from 'deepcopy';
import moment from 'moment';
import searchFilterMutations from './searchFilter/TripSearch.mutations.js';

function setValue(state, { value, key }) {
	state[key] = value;
}

function setTrips(state, { trips, externalTrips }) {
	state.trips = trips.concat(externalTrips).filter(x => Boolean(x)); // Filter out potential bad data
}

function updateTrips(state, trips) {
	for (let trip of trips) {
		if (!trip) continue;
		let index = state.trips.findIndex(x => x.id === trip.id);
		if (index === -1) {
			state.trips.push(trip);
		} else {
			state.trips[index] = trip;
			if (state.tripDetails.id === trip.id)
				state.tripDetails = state.trips[index];
		}
	}
}

function loadSavedSearch(state, savedSearch) {
	if (!savedSearch) return;
	state.loadedSearch = savedSearch;

	if (savedSearch.id === -1) { // reset
		state.searchFilter = {
			etd: {
				from: moment().subtract(7,'d').startOf('day')
					.format(storageDateFormat),
				to:''
			},
			fromLocation: [],
			toLocation: [],
			tripType: [],
			status: [],
			cargoCarrier: [],
		};
		state.loadedSearch = { id:-1, labelKey: 'searchForTrips' };
	} else {
		if (savedSearch.timeInterval.before) {
			let date = moment().add(savedSearch.timeInterval.before,'d').startOf('day');
			state.searchFilter.etd.from = date.format(storageDateFormat);
		}
		if (savedSearch.timeInterval.after) {
			let date = moment().add(savedSearch.timeInterval.after,'d').endOf('day');
			state.searchFilter.etd.to = date.format(storageDateFormat);
		}
		state.searchFilter.fromLocation = deepCopy(savedSearch.fromLocation || []);
		state.searchFilter.toLocation = deepCopy(savedSearch.toLocation || []);
		state.searchFilter.tripType = deepCopy(savedSearch.tripType || []);
		state.searchFilter.status = deepCopy(savedSearch.status || []);
		state.searchFilter.cargoCarrier = deepCopy(savedSearch.cargoCarrier || []);
	}
}

function setTripDetails(state, tripId) {
	let trip = state.trips.find( x => x && x.id === tripId);
	if (trip) state.tripDetails = trip;
	else state.tripDetails = null;
}

let set = (state, fn) => {
	if (fn)
		fn(state);
};

export default {
	...searchFilterMutations,
	setValue,
	setTrips,
	updateTrips,
	loadSavedSearch,
	setTripDetails,
	set,
};
